export class CallSummaryNode {

  /**
   * @example "Should the customer be directed to Trustpilot?"
   */
  readonly query: string;

  /**
   * For querying calls with a specific query and result.
   * @example "trustpilot"
   */
  readonly queryId?: string;
  readonly result: string;
  readonly iconName?: string;

  constructor(deriveFrom?: Partial<CallSummaryNode>) {
    if (deriveFrom) {
      Object.assign(this, deriveFrom);
    }
  }
}